import { render, staticRenderFns } from "./PurchasesDashboard.vue?vue&type=template&id=0410c1ad&lang=pug&"
import script from "./PurchasesDashboard.vue?vue&type=script&lang=js&"
export * from "./PurchasesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports